import {Injectable, OnDestroy} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, firstValueFrom, Observable, Subscription, switchMap} from 'rxjs';
import {environment} from '../../environments/environment';
import {SendHttpRequestService} from '../core/service/send-http-request.service';
import {getUtcOffSet} from '../../nbassist/functions/datetime';
import {SessionService} from '../core/service/session.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleService extends SendHttpRequestService implements OnDestroy {
  public subscription: Subscription = new Subscription();

  // public firebaseUser$: BehaviorSubject<firebase.User | undefined> = new BehaviorSubject<firebase.User | undefined>(undefined);
  //
  // private firebaseUser: firebase.User | undefined = undefined;
  //
  // private massiveAccessChecker = new MassiveAccessChecker(60, 54);

  private readonly host = 'https://' + environment.host;
  private readonly origin: string = 'https://' + environment.origin;
  private authForFirebase = '';

  constructor(
    private http: HttpClient,
    private sessionService: SessionService,
  ) {
    super();

    this.host = 'https://' + environment.host;
    this.origin = 'https://' + environment.origin;
    if (location.href.indexOf('localhost') !== -1) {
      // devサーバーを立てている場合
      // this.host = 'http://localhost:8080';
      this.origin = 'localhost:4200';
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * 事業所関連のヘッダを付与
   * 返り値： 事業所IDが設定されたヘッダ
   */
  private setJigyoushoHeaders() {
    // sessionServiceから取得
    const genzaiJigyoushoId = this.sessionService.session?.personalSetting?.customerId ?? '';
    let headers = new HttpHeaders();
    if (genzaiJigyoushoId != null) {
      headers = headers.append('Genzai-Jigyousho-Id', genzaiJigyoushoId);
    }
    return headers;
  }

  /**
   * GAEに対してリクエストを発行
   *
   * @param path リクエストパス
   * @param reQdto POSTのBody
   */
  request<T>(path: string, reQdto: any): Observable<T> {
    const headers = this.setJigyoushoHeaders();
    return this.requestWithHeaders<T>(path, reQdto, headers);
  }

  /**
   * GAEに対してリクエストを発行
   *
   * @param path リクエストパス
   * @param reQdto POSTのBody
   * @param headers HTTPリクエストのヘッダ
   */
  requestWithHeaders<T>(path: string, reQdto: any, headers: HttpHeaders): Observable<T> {
    return new Observable<T>(observer => {
      // const massiveAccessCheck = this.massiveAccessChecker.isMassiveAccess();
      // if (massiveAccessCheck.isConsectiveAccess) {
      //   // 連続アクセス発生時にはリクエストを抑制
      //   const response = new HttpErrorResponse({
      //     status: 503,
      //     statusText: this.translateService.instant('sentence.suspendedForMassiveAccess')
      //   });
      //   observer.error(response);
      //
      //   if (massiveAccessCheck.isFirst) {
      //     const message = this.translateService.instant('error.isConsecutiveAccess');
      //     this.sendRequest('/log/client', {
      //       message, // message: message と同義
      //     }, null)
      //       .subscribe(() => {}, () => {}); // 応答は使用しない
      //
      //     alert(message);
      //   }
      // } else {
      //   this.sendRequest<T>(path, reQdto, headers).subscribe(
      //     response => {
      //       observer.next(response);
      //     },
      //     (error: HttpErrorResponse) => {
      //       observer.error(error);
      //     },
      //     () => {
      //       observer.complete();
      //     }
      //   );
      // }
      this.sendRequest<T>(path, reQdto, headers).subscribe(
        response => {
          observer.next(response);
        },
        (error: HttpErrorResponse) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        }
      );
      // }
    });
  }

  /**
   * GAEにリクエストを発行する実体（request 及び requestWithHeaders より呼ばれる)
   *
   * @param path リクエストパス
   * @param reQdto POSTのBody
   * @param headers HTTPリクエストのヘッダ
   */
  sendRequest<T>(path: string, reQdto: any, headers: HttpHeaders | null): Observable<T> {
    return this.setCommonHeaders(headers).pipe(
      switchMap(h => this.http.post<T>(
        this.host + path,
        reQdto,
        {
          headers: h,
        }
      ))
    );
  }

  /**
   * 共通ヘッダを付与
   *
   * @param headers すでに追加済みのヘッダ
   * @return 共通ヘッダを追加した新たなヘッダへの Observable
   */
  setCommonHeaders(headers: HttpHeaders | null): Observable<HttpHeaders> {
    return new Observable<HttpHeaders>( observer => {
      if (headers == null) {
        headers = new HttpHeaders();
      }
      let newHeaders = headers; // Callback内で Possibly Undefined とならないように新たな変数を設ける。
      newHeaders = newHeaders.append('Content-Type', 'application/json');
      newHeaders = newHeaders.append('UtcOffSet', getUtcOffSet());
      newHeaders = newHeaders.append('Access-Control-Allow-Origin', this.origin);
      // この設定はNCPを踏襲しているが、不要かもしれない
      newHeaders = newHeaders.append('Authorization', 'Bearer ' + this.authForFirebase);

      // if (this.firebaseUser != null) {
      //   this.firebaseUser.getIdToken()
      //     .then(idToken => {
      //       headers = newHeaders.append('Firebase-Id-Token', idToken);
      //       observer.next(headers);
      //       observer.complete();
      //     });
      // } else {
      //   observer.next(headers);
      //   observer.complete();
      // }

      observer.next(newHeaders);
      observer.complete();
    });
  }

  /**
   * HTTPでエラーが発生した場合のハンドラ
   *
   * @param resp HTTPエラーレスポンス
   */
  errorHandler(resp: HttpErrorResponse): void {
    const status = resp.status;
    if ( status === 401) {
      // this.signOut();
    } else {
      let message;
      if (resp.error != null && resp.error.error != null) {
        message = resp.error.error;
      } else {
        message = resp.statusText;
      }
      alert(message);
    }
  }
}
